import React, { useState } from "react";
import avatar from "../../assets/avatar.png";
import { ChatList } from "../../utils/tools/chat";
import Button from "../Button";
import Input from "../Input";

const MessageBox = ({ id, setMessageBoxShow }) => {
  const findPeople = ChatList?.find((people) => people?.id === id);
  const [value, setValue] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(value);
  };
  return (
    <div className="message_writing_box">
      <div className="heading">
        <div className="heading_info">
          <img src={avatar} width="100%" alt="img" />
          <span
            style={{
              backgroundColor: `${findPeople?.status ? "#31cc46" : "#cc4331"}`,
            }}
          ></span>
          <div className="name">
            <h2>{findPeople?.name}</h2>
            <p>{findPeople?.status ? "Active now" : "Last seen 14m ago"}</p>
          </div>
        </div>
        <div className="cancel_btn">
          <span onClick={() => setMessageBoxShow(false)}>X</span>
        </div>
      </div>
      <div className="body">
        <div className="messages">
          {findPeople.conversation.map((d, i) => (
            <>
              <div className="flex_container start">
                <img src={avatar} width="100%" alt="img" />
                <div className="msg_cont">
                  {d.m1}
                  <p>08:47 PM, today</p>
                </div>
              </div>
              <div className="flex_container end">
                <div className="msg_cont">
                  {d.m2}
                  <p>08:48 PM, today</p>
                </div>
                <img src={avatar} width="100%" alt="img" />
              </div>
            </>
          ))}
        </div>
      </div>
      <div className="footer">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <Input
              type="text"
              placeholder="Type a message..."
              name="message"
              onChange={(e) => setValue(e.target.value)}
              className="message_input"
            />
            <Button type="submit" className="message_btn">
              send
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MessageBox;
